<template>
  <div class="statView main_view">
    <header-comp/>
    <div class="view_grid">
      <navbar-comp :active="'stat'" class="navbar"/>
      <div>
        <tabs-comp :moduleName="moduleName"/>
        <chart-orders-proceeds-comp v-if="tabs.proceeds.active"/>
        <chart-orders-massage-comp v-if="tabs.massage.active"/>
        <chart-orders-rating-comp v-if="tabs.rating.active"/>
        <!-- <chart-orders-kpd-comp v-if="tabs.kpd.active"/> -->
        <chart-questions-comp v-if="role == 'admin' && tabs.questions.active"/>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'statView',
  components: {},
  data: function () {
    return {
      moduleName: 'stat'
    }
  },
  computed: {
    tabs: function () {
      return this.$store.getters[`${this.moduleName}/getTabs`]
    },
    role: function () {
      return localStorage.getItem('role')
    }
  },
  created: function () {
  },
  methods: {}
}
</script>
